import React, { createContext, useMemo, useState } from "react";

export const MainContext = createContext(null);

export const MainProvider = ({ children }) => {
  const [landingOpen, setlandingOpen] = useState(true);

  const contextValue = useMemo(
    () => ({
      landingOpen,
      setlandingOpen,
    }),
    [landingOpen, setlandingOpen],
  );

  return <MainContext.Provider value={contextValue}>{children}</MainContext.Provider>;
};
